@if (isDataLoaded$ | async) {
  <div fxFlexFill fxLayout="column" fxLayoutAlign="start stretch">
    <h1 mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center" style="padding-top: 10px">
      <div fxFlex>Configure Device: {{ deviceModelTitle }} Buttons</div>
      <button mat-icon-button [mat-dialog-close]="false" class="button-40">
        <mat-icon>close</mat-icon>
      </button>
    </h1>
    <mat-dialog-content style="display: flex; align-items: stretch; justify-content: center">
      <div
        fxLayout="row"
        fxLayoutAlign="space-between"
        fxLayoutGap="20px"
        fxFlexFill
        fxLayout.sm="column"
        fxLayout.xs="column"
      >
        <div fxFlex="50" fxFlex.sm="100">
          @if (!isExpansionMode) {
            @if (isDefaultDevice) {
              <div style="display: flex; justify-content: center; position: sticky">
                <p>Template for device: "{{ deviceModelTitle }}" not available</p>
              </div>
            } @else {
              <ng-content></ng-content>
            }
          } @else {
            @if (isYealinkDevice) {
              <app-yealink-exp43 #expansionModule></app-yealink-exp43>
            } @else {
              <div style="display: flex; justify-content: center; position: sticky">
                <p>Expansion module template for device: "{{ deviceModelTitle }}" not available</p>
              </div>
            }
          }
        </div>

        <div fxFlex="50" fxFlex.sm="100" fxLayout="column" style="height: 100%; min-height: 0">
          <!-- Paginator -->

          @if (isExpansionAvailable) {
            <button mat-raised-button style="margin-bottom: 10px" (click)="onDeviceSwitch()">
              switch to {{ isExpansionMode ? 'phone' : 'expansion module' }}
            </button>
          }

          @if (isPagingAvailable) {
            <div class="paginator" style="display: flex; align-items: center; justify-content: flex-end">
              <button mat-icon-button (click)="onButtonsPageChange(activePage - 1)" [disabled]="activePage === 0">
                <mat-icon>chevron_left</mat-icon>
              </button>
              <span fxLayout fxHide="xs" style="margin: 0 8px; font-weight: bold"
                >Page {{ activePage + 1 }} of {{ 3 }}</span
              >
              <button mat-icon-button (click)="onButtonsPageChange(activePage + 1)" [disabled]="activePage === 2">
                <mat-icon>chevron_right</mat-icon>
              </button>
            </div>
          }

          <!-- SCROLLABLE button area -->
          <div style="flex: 1; overflow-y: auto; min-height: 0; margin-bottom: 10px; padding: 1px">
            <mat-accordion>
              @for (buttonGroup of paginatedButtons; track buttonGroup; let i = $index) {
                <app-device-button
                  [buttonForm]="buttonGroup"
                  [lookupButtonTypes]="lookupButtonTypes"
                  [formSubmitted]="formSubmitted$ | async"
                  [btnIndex]="i"
                  (expansionOpened)="onExpansionToggle(i, true)"
                  (expansionClosed)="onExpansionToggle(i, false)"
                ></app-device-button>
              }
            </mat-accordion>
          </div>

          <!-- Action buttons (fixed bottom) -->
          <div mat-dialog-actions style="padding: 0px; margin-top: 10px">
            <div fxLayout="row" fxLayoutAlign="space-between center" fxFlex="100" fxLayoutGap="8px" style="width: 100%">
              <!-- Left Buttons -->
              <div fxLayout="row" fxLayoutGap="8px">
                <button
                  type="button"
                  mat-raised-button
                  color="warn"
                  style="width: 100%"
                  [disabled]="formSubmitted$ | async"
                  (click)="onButtonsClear()"
                >
                  Clear All
                </button>

                <button
                  type="button"
                  style="width: 100%"
                  mat-raised-button
                  color="primary"
                  [matMenuTriggerFor]="templateActionsMenu"
                >
                  Templates
                  <mat-menu #templateActionsMenu="matMenu">
                    <button
                      mat-menu-item
                      type="button"
                      fxLayout="row"
                      fxLayoutAlign="start center"
                      (click)="onManageTemplates()"
                    >
                      <mat-icon>add</mat-icon>
                      Add Template
                    </button>
                    <button
                      mat-menu-item
                      type="button"
                      fxLayout="row"
                      fxLayoutAlign="start center"
                      (click)="onSaveAsTemplate()"
                    >
                      <mat-icon>save</mat-icon>
                      Save As Template
                    </button>
                  </mat-menu>
                </button>
              </div>

              <!-- Right Buttons -->
              <div fxLayout="row" fxLayoutAlign="end" fxLayoutGap="8px">
                <button
                  type="button"
                  mat-raised-button
                  color="primary"
                  [disabled]="!isFormValid || (formSubmitted$ | async)"
                  [promiseBtn]="formSubmitted$ | async"
                  (click)="onSave()"
                >
                  Save
                </button>
                <button type="button" mat-stroked-button [mat-dialog-close]="false">Close</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-dialog-content>
  </div>
} @else {
  <div fxLayout="column" fxFlexFill class="spinner-container">
    <mat-spinner></mat-spinner>
  </div>
}
